import React, { JSX } from 'react';
import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import Icons from 'components/atoms/Icons';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type SocialMediaLinksProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    SocialMediaLinks: Array<SocialMediaLinksContent>;
    Title: Field<string>;
  };
};

type SocialMediaLinksContent = {
  name?: string;
  displayName: string;
  fields: {
    BaseLink: {
      value: {
        href: string;
        url: string;
        text: string;
      };
    };
    BaseSvg: {
      value: string;
    };
  };
};

const getSocialLinkAriaLabel = (item: SocialMediaLinksContent): string => {
  const label =
    item.displayName ||
    item.name ||
    item.fields?.BaseLink?.value?.text ||
    item.fields?.BaseSvg?.value ||
    item.fields?.BaseLink?.value?.href ||
    'Social media link';

  return `${label} (opens in a new tab)`;
};

const SocialMediaLinks = (props: SocialMediaLinksProps): JSX.Element => {
  if (props == undefined) {
    return <div>Data source is not defined</div>;
  }
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;
  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`social-media-links-${props.rendering?.uid}`}
    >
      <div className="gradient-bg-dark-light">
        <div className="jss-inner-container inner-vertical-spacing">
          <div className="social-media-links">
            <Text
              className="social-description"
              tag="h3"
              field={fields?.Title}
            />
            <div className="social-links">
              {fields?.SocialMediaLinks?.map((item, index) => (
                <a
                  key={index}
                  className="social-link"
                  target="_blank"
                  rel="noreferrer"
                  href={item.fields?.BaseLink?.value?.href || '#'}
                  aria-label={getSocialLinkAriaLabel(item)}
                >
                  <span className={`icon icon-${item.fields?.BaseSvg?.value}`}>
                    <Icons id={item.fields?.BaseSvg?.value} />
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaLinks;
